import { ref, computed, watch } from "vue";
import { serviceList } from "@/views/service-list";
import { currentServiceSpec, ServiceSpec } from "@/views/service/service-spec";
import Service from "@/code/service";
import { formatServiceId } from "@/code/admin";

export let currentService: Service = null;
export let currentServiceId = ref("");
export let serviceMainLoaded = ref(false);
export let serviceUsers: any = {};
export let serviceRecords: any = {};
export let serviceBins: any = {};
export let serviceAutoMails: any = {};
export let serviceBulkMails: any = {};
export let serviceUpgradeOffer = ref(false);
export let registerAliasRunning = ref(false);
export let registerSubdomainRunning = ref(false);
export let initialLoadDone = ref(false);

// formatted Service ID
// export const formattedServiceId = computed(() => {
//     console.log("currentService in formattedServiceId:", currentService.id);
//     if (!currentService || !currentService.id || !currentService.owner) {
//         return "";
//     }
//     return formatServiceId(currentService.id, currentService.owner);
// });

// const serviceChangedEvent = new Event("serviceChanged");

export let formattedServiceId = ref("");
watch(currentServiceId, (nv) => {
    if (nv) {
        if (!currentService || !currentService.id || !currentService.owner) {
            return "";
        }
        formattedServiceId.value = formatServiceId(
            currentService.id,
            currentService.owner,
        );
    }
});

export let setService = async (specObj: ServiceSpec) => {
    // 만약에 경로에 있는 서비스 아이디 앞에 pend- 가 붙어있다면 제거
    const router = (await import("@/router")).default;
    const currentRoute = router.currentRoute?.value;
    if (currentRoute) {
        const routeServiceId = (currentRoute.params?.service as string) || "";
        if (routeServiceId.startsWith("pend-")) {
            const newServiceId = routeServiceId.replace("pend-", "");
            router.replace({
                ...currentRoute,
                params: { ...currentRoute.params, service: newServiceId },
            });
        }
    }

    serviceMainLoaded.value = false;
    currentService = serviceList[specObj.service.id];
    currentServiceSpec.value = specObj;
    currentServiceId.value = specObj.service.id;
    serviceMainLoaded.value = true;

    if (!initialLoadDone.value) {
        initialLoadDone.value = true;
    }

    // window.dispatchEvent(serviceChangedEvent);
};

export let serviceLoggers: any = {};
